import { useEffect, useState } from 'react';
import GaugeComponent from "react-gauge-component";
import axios from 'axios';
import qs from 'qs';
import { useParams, useHistory } from 'react-router-dom';
import { NotificationManager } from 'react-notifications';
import Access from "./components/Access";
import Navbar from "./components/Navbar";
import Gantt from "./components/GanttComponent";
import Dialog from "./components/Dialog";
import ModalPilotage from "./components/ModalPilotage";
import { ReactComponent as Check } from './Img/icon-check.svg';
import { ReactComponent as Add } from './Img/icon-add.svg';
import { ReactComponent as Trash } from './Img/icon-trash.svg';
import { addSpace, rescueHtml } from "./components/Tools";
import IncidencesFinancieresOperations from './components/IncidencesFinancieresOperations';

const OperationPage = (props) => {
    const { id } = useParams();
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const [operation, setOperation] = useState(null);
    const [modalites, setModalites] = useState([]);
    const [modalite_portage_selectionnee, setModalite_portage_selectionnee] = useState(null);
    const [axes, setAxes] = useState([]);
    const [clients, setClients] = useState([]);
    const [aff, setAff] = useState(false);
    const [details, setDetails] = useState(true);
    const [moyens, setMoyens] = useState(false);
    const [echeancier, setEcheancier] = useState(false);
    const [incidences, setIncidences] = useState(false);
    const [incidences_financieres, setIncidences_financieres] = useState({});
    const [evaluation, setEvaluation] = useState(false);
    const [pilotage, setPilotage] = useState(false);
    const [pilotage_operation, setPilotage_operation] = useState([]);
    const [modalPilotage, setModalPilotage] = useState(false);
    const [objetPilotage, setObjetPilotage] = useState(false);
    const [dialogModalVisible, setDialogModalVisible] = useState(false);
    const [pilotageLineSelected, setPilotageLineSelected] = useState(null);
    const heightObject = window.innerHeight/1.9;

    const purple = '#6571FE';
    const blue = '#069BD3';
    const green = '#59B44A';
    const orange = '#FFA500';
    const red = '#FF0000';
    const greyChapter = '#DBDBDB';

    async function callbackDialog(ret) {
        if (ret === true) {
            await suppressLinePilotage();
        }
        else {
            await setPilotageLineSelected(null);
        }
    }

    async function suppressLinePilotage() {
        pilotage_operation.forEach((element, i) => {
            if (element[0] === pilotageLineSelected) {
                delete pilotage_operation[i];
            }
        });
        await setPilotageLineSelected(null);
    }

    async function addLinePilotage() {
        let date = new Date();
        let yyyy = date.getFullYear();
        let mm = date.getMonth() + 1;
        let dd = date.getDate();
        if (dd < 10) {
            dd = '0'+dd;
        }
        if (mm < 10) {
            mm = '0'+mm;
        }
        
        var tmp = [
            'tmp_'+pilotage_operation.length,//[0] id
            null,//                            [1] id_projet (null pour opération)
            id,//                              [2] id_operation
            yyyy+'-'+mm+'-'+dd,//              [3] date
            '',//                              [4] instance reunie
            '',//                              [5] releve decision
            '',//                              [6] action suivante
            '0000-00-00',//                    [7] date limite
            '',//                              [8] responsable action
            '',//                              [9] liste mails
            ''//                               [10] action terminee
        ];
        await pilotage_operation.push(tmp)
        await setAff(!aff);
    }

    useEffect(() => {
        if (!id) return;
        if (props.user === null) {
            props.getUser();
        } else {
            mount();
        }
    }, [id, props.user]);

    async function mount() {
        // Fetch operation
        try {
            const res = await axios.get('/api/operations.php?id=' + encodeURIComponent(id));
            if (res && res.data && res.data.status === 1 && res.data.data) {
                const operationData = res.data.data;
                
                // Vérification de sécurité : l'opération doit appartenir au budget de l'utilisateur
                if (props.user && props.user.id_budget && operationData.id_budget != props.user.id_budget) {
                    NotificationManager.error('Vous n\'avez pas accès à cette opération', '', 3000);
                    setTimeout(() => {
                        history.push('/operations');
                    }, 1500);
                    return;
                }
                
                // Convertir les IDs en nombres pour assurer la sélection correcte dans les selects
                if (operationData.id_clients_epfl) operationData.id_clients_epfl = parseInt(operationData.id_clients_epfl);
                if (operationData.id_axes_interventions) operationData.id_axes_interventions = parseInt(operationData.id_axes_interventions);
                if (operationData.id_modalite_portage) operationData.id_modalite_portage = parseInt(operationData.id_modalite_portage);
                
                setOperation(operationData);
            } else {
                NotificationManager.error((res && res.data && res.data.message) || 'Opération introuvable', '', 3000);
            }
        } catch (e) {
            console.error(e);
            NotificationManager.error('Erreur récupération opération', '', 3000);
        }

        // Fetch modalites
        if (props.user && props.user.id_organisme) {
            try {
                const rm = await axios.post('/api/modalites_portage.php', qs.stringify({ get: true, id_organisme: props.user.id_organisme }));
                if (rm && rm.data) {
                    const list = Array.isArray(rm.data) ? rm.data : (rm.data.data ? rm.data.data : []);
                    setModalites(list || []);
                } else setModalites([]);
            } catch (err) {
                console.warn(err);
                setModalites([]);
            }

            // Fetch axes
            try {
                const ra = await axios.post('/api/axes_interventions.php', qs.stringify({ get: true, id_organisme: props.user.id_organisme }));
                if (ra && ra.data) {
                    const list = Array.isArray(ra.data) ? ra.data : (ra.data.data ? ra.data.data : []);
                    setAxes(list || []);
                } else setAxes([]);
            } catch (err) {
                console.warn(err);
                setAxes([]);
            }

            // Fetch clients
            try {
                const rc = await axios.post('/api/clients_epfl.php', qs.stringify({ get: true, id_organisme: props.user.id_organisme }));
                if (rc && rc.data) {
                    const list = Array.isArray(rc.data) ? rc.data : (rc.data.data ? rc.data.data : []);
                    setClients(list || []);
                } else setClients([]);
            } catch (err) {
                console.warn(err);
                setClients([]);
            }
        }

        // Fetch pilotage
        try {
            const rp = await axios.post('/api/pilotage_projet.php', qs.stringify({ get: true, id_operation: id }));
            if (rp && rp.data) {
                setPilotage_operation(rp.data);
            }
        } catch (err) {
            console.warn(err);
            setPilotage_operation([]);
        }

        // Fetch incidences financières
        await loadIncidencesFinancieres(id);
    }

    async function loadIncidencesFinancieres(operationId) {
        try {
            const response = await axios.post('/api/incidences_financieres_operations.php', qs.stringify({
                action: 'get_by_operation',
                id_operation: operationId
            }));
            
            if (response && response.data && response.data.status === 1 && response.data.data) {
                const incidencesData = response.data.data;
                const incidencesObj = {};
                
                // Calculer yearAcquisition pour retrouver l'index à partir de annee
                setOperation(prevOp => {
                    if (!prevOp) return prevOp;
                    
                    let yearAcquisition = null;
                    if (prevOp.date_premiere_acquisition) {
                        yearAcquisition = new Date(prevOp.date_premiere_acquisition).getFullYear();
                    }
                    
                    // Remplir l'objet incidences avec toutes les données
                    incidencesData.forEach(row => {
                        const year = parseInt(row.annee);
                        const yearIdx = yearAcquisition ? year - yearAcquisition : 0;
                        
                        // Champs d'entrée (saisie)
                        incidencesObj[`incidences_prix_acquisition_${yearIdx}`] = row.incidences_prix_acquisition || '';
                        incidencesObj[`incidences_frais_actes_${yearIdx}`] = row.incidences_frais_actes || '';
                        incidencesObj[`incidences_subventions_${yearIdx}`] = row.incidences_subventions || '';
                        incidencesObj[`incidences_montant_retrocessions_${yearIdx}`] = row.incidences_montant_retrocessions || '';
                        incidencesObj[`incidences_frais_prealables_${yearIdx}`] = row.incidences_frais_prealables || '';
                        incidencesObj[`incidences_frais_annexes_${yearIdx}`] = row.incidences_frais_annexes || '';
                        incidencesObj[`incidences_frais_gegr_${yearIdx}`] = row.incidences_frais_gegr || '';
                        incidencesObj[`incidences_frais_proto_amenagement_${yearIdx}`] = row.incidences_frais_proto_amenagement || '';
                        incidencesObj[`incidences_annuite_capital_porte_reel_${yearIdx}`] = row.incidences_annuite_capital_porte_reel || '';
                        incidencesObj[`incidences_annuite_hors_capital_porte_reel_${yearIdx}`] = row.incidences_annuite_hors_capital_porte_reel || '';
                        incidencesObj[`incidences_taux_${yearIdx}`] = row.incidences_taux || '';
                        incidencesObj[`incidences_entretien_reparations_${yearIdx}`] = row.incidences_entretien_reparations || '';
                        incidencesObj[`incidences_eau_electricite_${yearIdx}`] = row.incidences_eau_electricite || '';
                        incidencesObj[`incidences_charges_copropriete_${yearIdx}`] = row.incidences_charges_copropriete || '';
                        incidencesObj[`incidences_taxes_foncieres_${yearIdx}`] = row.incidences_taxes_foncieres || '';
                        incidencesObj[`incidences_taxe_redevance_om_${yearIdx}`] = row.incidences_taxe_redevance_om || '';
                        incidencesObj[`incidences_assurances_${yearIdx}`] = row.incidences_assurances || '';
                        incidencesObj[`incidences_autres_depenses_${yearIdx}`] = row.incidences_autres_depenses || '';
                        incidencesObj[`incidences_loyers_percus_${yearIdx}`] = row.incidences_loyers_percus || '';
                        incidencesObj[`incidences_refacturation_eau_electricite_${yearIdx}`] = row.incidences_refacturation_eau_electricite || '';
                        incidencesObj[`incidences_refacturation_charges_copropriete_${yearIdx}`] = row.incidences_refacturation_charges_copropriete || '';
                        incidencesObj[`incidences_refacturation_taxes_foncieres_${yearIdx}`] = row.incidences_refacturation_taxes_foncieres || '';
                        incidencesObj[`incidences_refacturation_om_${yearIdx}`] = row.incidences_refacturation_om || '';
                        incidencesObj[`incidences_refacturation_assurances_${yearIdx}`] = row.incidences_refacturation_assurances || '';
                        incidencesObj[`incidences_autres_recettes_${yearIdx}`] = row.incidences_autres_recettes || '';
                        
                        // Champs calculés
                        incidencesObj[`incidences_total_annuel_capital_porte_${yearIdx}`] = row.incidences_total_annuel_capital_porte || '';
                        incidencesObj[`incidences_total_annuel_hors_capital_porte_${yearIdx}`] = row.incidences_total_annuel_hors_capital_porte || '';
                        incidencesObj[`incidences_annuite_capital_porte_${yearIdx}`] = row.incidences_annuite_capital_porte || '';
                        incidencesObj[`incidences_annuite_hors_capital_porte_${yearIdx}`] = row.incidences_annuite_hors_capital_porte || '';
                        incidencesObj[`incidences_annuite_definitive_${yearIdx}`] = row.incidences_annuite_definitive || '';
                        incidencesObj[`incidences_capital_stocke_${yearIdx}`] = row.incidences_capital_stocke || '';
                        incidencesObj[`incidences_calcul_frais_portage_${yearIdx}`] = row.incidences_calcul_frais_portage || '';
                        incidencesObj[`incidences_frais_portage_ht_${yearIdx}`] = row.incidences_frais_portage_ht || '';
                        incidencesObj[`incidences_tva_frais_portage_${yearIdx}`] = row.incidences_tva_frais_portage || '';
                        incidencesObj[`incidences_frais_portage_ttc_${yearIdx}`] = row.incidences_frais_portage_ttc || '';
                        incidencesObj[`incidences_total_depenses_${yearIdx}`] = row.incidences_total_depenses || '';
                        incidencesObj[`incidences_total_recettes_${yearIdx}`] = row.incidences_total_recettes || '';
                        incidencesObj[`incidences_solde_annuel_frais_gestion_${yearIdx}`] = row.incidences_solde_annuel_frais_gestion || '';
                        incidencesObj[`incidences_solde_cumule_frais_gestion_${yearIdx}`] = row.incidences_solde_cumule_frais_gestion || '';
                        incidencesObj[`incidences_solde_operation_${yearIdx}`] = row.incidences_solde_operation || '';
                    });
                    
                    return prevOp;
                });
                
                // Remplir le state des incidences financières
                setIncidences_financieres(incidencesObj);
            }
        } catch (err) {
            console.warn('Erreur lors du chargement des incidences financières:', err);
        }
    }

    async function saveIncidencesFinancieres() {
        if (!operation || !operation.duree_portage || !operation.id) {
            console.warn('saveIncidencesFinancieres: pas d\'opération, pas de durée, ou pas d\'ID');
            return;
        }

        try {
            const duree = parseInt(operation.duree_portage);
            
            // Calculer yearFirstFacturationIdx
            let yearFirstFacturationIdx = 0;
            let yearAcquisition = null;
            if (operation.date_premiere_acquisition && operation.date_premiere_facturation) {
                yearAcquisition = new Date(operation.date_premiere_acquisition).getFullYear();
                const yearFirstFacturation = new Date(operation.date_premiere_facturation).getFullYear();
                yearFirstFacturationIdx = yearFirstFacturation - yearAcquisition;
            } else if (operation.date_premiere_acquisition) {
                yearAcquisition = new Date(operation.date_premiere_acquisition).getFullYear();
            }
            
            const totalYears = yearFirstFacturationIdx + duree;
            
            // Préparer l'objet de données à envoyer
            const incidenceData = {
                action: 'create',
                id_operation: operation.id,
                duree_portage: duree
            };
            
            // Listes pour distinguer les champs d'entrée (saisie) des champs calculés
            const inputFields = [
                'incidences_prix_acquisition',
                'incidences_frais_actes',
                'incidences_subventions',
                'incidences_montant_retrocessions',
                'incidences_frais_prealables',
                'incidences_frais_annexes',
                'incidences_frais_gegr',
                'incidences_frais_proto_amenagement',
                'incidences_annuite_capital_porte_reel',
                'incidences_annuite_hors_capital_porte_reel',
                'incidences_taux',
                'incidences_entretien_reparations',
                'incidences_eau_electricite',
                'incidences_charges_copropriete',
                'incidences_taxes_foncieres',
                'incidences_taxe_redevance_om',
                'incidences_assurances',
                'incidences_autres_depenses',
                'incidences_loyers_percus',
                'incidences_refacturation_eau_electricite',
                'incidences_refacturation_charges_copropriete',
                'incidences_refacturation_taxes_foncieres',
                'incidences_refacturation_om',
                'incidences_refacturation_assurances',
                'incidences_autres_recettes'
            ];
            
            const calculatedFields = [
                'incidences_total_annuel_capital_porte',
                'incidences_total_annuel_hors_capital_porte',
                'incidences_annuite_capital_porte',
                'incidences_annuite_hors_capital_porte',
                'incidences_annuite_definitive',
                'incidences_capital_stocke',
                'incidences_calcul_frais_portage',
                'incidences_frais_portage_ht',
                'incidences_tva_frais_portage',
                'incidences_frais_portage_ttc',
                'incidences_total_depenses',
                'incidences_total_recettes',
                'incidences_solde_annuel_frais_gestion',
                'incidences_solde_cumule_frais_gestion',
                'incidences_solde_operation'
            ];
            
            // Pour chaque année (y compris les années avant le portage), ajouter tous les champs
            for (let yearIdx = 0; yearIdx < totalYears; yearIdx++) {
                // Calculer l'année réelle
                const year = yearAcquisition ? yearAcquisition + yearIdx : yearIdx;
                
                // Lire les champs d'entrée depuis incidences_financieres (données saisies par l'utilisateur)
                inputFields.forEach(fieldName => {
                    const key = `${fieldName}_${yearIdx}`;
                    incidenceData[key] = incidences_financieres[key] ?? 0;
                });
                
                // Lire les champs calculés depuis operation
                calculatedFields.forEach(fieldName => {
                    const key = `${fieldName}_${yearIdx}`;
                    incidenceData[key] = operation[key] ?? 0;
                });
                
                // Ajouter l'année réelle pour cette ligne
                incidenceData[`year_index_${yearIdx}`] = year;
            }
            
            console.log('Données envoyées:', incidenceData);
            const response = await axios.post('/api/incidences_financieres_operations.php', qs.stringify(incidenceData));
            console.log('Réponse serveur:', response.data);
            
            if (!response.data || response.data.status !== 1) {
                throw new Error(response.data?.message || 'Erreur lors de la sauvegarde');
            }
            
        } catch (err) {
            if (err.response) {
            }
            throw err;
        }
    }

    const valider = async () => {
        if (!operation) return false;
        
        if (!operation.nom || !operation.nom.trim()) {
            NotificationManager.error('Le champ "Nom" est requis', '', 2500);
            return false;
        }

        setLoading(true);
        try {
            const params = {
                update: true,
                id: id,
                id_budget: operation.id_budget,
                numero_inventaire: operation.numero_inventaire,
                nom: operation.nom,
                enjeu: operation.enjeu,
                id_modalite_portage: operation.id_modalite_portage,
                date_premiere_acquisition: operation.date_premiere_acquisition,
                date_premiere_facturation: operation.date_premiere_facturation,
                duree_portage: operation.duree_portage,
                duree_differe: operation.duree_differe,
                id_axes_interventions: operation.id_axes_interventions,
                gestionnaire_interne: operation.gestionnaire_interne,
                montant: operation.montant,
                description: operation.description,
                gestionnaire: operation.gestionnaire,
                prerequis_mise_en_oeuvre: operation.prerequis_mise_en_oeuvre,
                questions: operation.questions,
                id_clients_epfl: operation.id_clients_epfl,
                partenaires: operation.partenaires,
                service_referent: operation.service_referent,
                technicien_nom: operation.technicien_nom,
                technicien_mail: operation.technicien_mail,
                technicien_telephone: operation.technicien_telephone,
                technicien_fonction: operation.technicien_fonction,
                ressources_humaines: operation.ressources_humaines,
                etudes: operation.etudes,
                outils: operation.outils,
                investissements: operation.investissements,
                incidences_orga: operation.incidences_orga,
                etudes_programmatiques: operation.etudes_programmatiques,
                description_objectifs: operation.description_objectifs,
                niveau_atteinte_objectifs: operation.niveau_atteinte_objectifs,
                note: operation.note,
                ajustement_objectifs: operation.ajustement_objectifs,
                color: operation.color,
                h1: operation.h1 || 0,
                h2: operation.h2 || 0,
                h3: operation.h3 || 0
            };
            const res = await axios.post('/api/operations.php', qs.stringify(params));
            if (res && res.data && res.data.status === 1) {
                NotificationManager.success('Opération mise à jour', '', 2000);
                
                // Sauvegarder le pilotage
                try {
                    await axios.post('/api/pilotage_projet.php', qs.stringify({
                        'update': true,
                        'id_operation': id,
                        'objet': pilotage_operation
                    }));
                } catch (e) {
                    console.error('Erreur sauvegarde pilotage:', e);
                }

                // Sauvegarder les incidences financières
                try {
                    console.log('********** Sauvegarde des incidences financières ***********');
                    await saveIncidencesFinancieres();
                } catch (e) {
                    console.error('Erreur sauvegarde incidences financières:', e);
                }
                
                setLoading(false);
                return true;
            } else {
                NotificationManager.error((res && res.data && res.data.message) || 'Erreur mise à jour', '', 3000);
                setLoading(false);
                return false;
            }
        } catch (e) {
            console.error(e);
            NotificationManager.error('Erreur requête serveur', '', 3000);
            setLoading(false);
            return false;
        }
    };

    const updateField = (field, value) => {
        var tmp = operation;
        for (let key in tmp) {
            if (key === field) {
                tmp[key] = value;
                break;
            }
        }
        setOperation(tmp);
        setAff(!aff);
    };

    const updateIncidencesFinancieres = (field, value) => {
        setIncidences_financieres({
            ...incidences_financieres,
            [field]: (value + 0)
        });
    };

    const recalculateAfterBlur = (field, yearIdx, incidencesUpdated = null) => {
        // Recalculate all calculated fields in the table after any input blur
        if (!operation || !operation.duree_portage) {
            return;
        }
        recalculateAllTableFields(incidencesUpdated);
    };

    const recalculateAllTableFields = (incidencesUpdated = null) => {
        // Recalculate all fields in the entire table
        if (!operation || !operation.duree_portage) {
            return;
        }
        
        const DP = parseInt(operation.duree_portage);
        let yearFirstFacturationIdx = 0;
        if (operation.date_premiere_acquisition && operation.date_premiere_facturation) {
            const yearAcquisition = new Date(operation.date_premiere_acquisition).getFullYear();
            const yearFirstFacturation = new Date(operation.date_premiere_facturation).getFullYear();
            yearFirstFacturationIdx = yearFirstFacturation - yearAcquisition;
        }
        
        const updatedOperation = { ...operation };
        
        // Ajouter le taux de la modalité de portage pour les calculs
        if (modalite_portage_selectionnee && modalite_portage_selectionnee.taux) {
            updatedOperation.taux_frais_modalite = parseFloat(modalite_portage_selectionnee.taux);
        }
        
        // Utiliser incidencesUpdated si fourni (nouvelle valeur du onBlur), sinon utiliser le state current
        const incidencesToUse = incidencesUpdated || incidences_financieres;
        
        // Copier les données d'entrée depuis incidences pour que les calculs utilisent les valeurs fraîches
        Object.keys(incidencesToUse).forEach(key => {
            updatedOperation[key] = incidencesToUse[key];
        });
        const totalYears = yearFirstFacturationIdx + DP;
        
        // Pour chaque année de la table (y compris les années avant le portage)
        for (let yearIdx = 0; yearIdx < totalYears; yearIdx++) {
            // ST1
            const ST1 = parseFloat(calculateIncidencesField(`incidences_total_annuel_capital_porte_${yearIdx}`, yearIdx, updatedOperation)) || 0;
            updatedOperation[`incidences_total_annuel_capital_porte_${yearIdx}`] = ST1;
            
            // ST2
            const ST2 = parseFloat(calculateIncidencesField(`incidences_total_annuel_hors_capital_porte_${yearIdx}`, yearIdx, updatedOperation)) || 0;
            updatedOperation[`incidences_total_annuel_hors_capital_porte_${yearIdx}`] = ST2;
            
            // AKP
            const AKP = parseFloat(calculateIncidencesField(`incidences_annuite_capital_porte_${yearIdx}`, yearIdx, updatedOperation)) || 0;
            updatedOperation[`incidences_annuite_capital_porte_${yearIdx}`] = AKP;
            
            // AHKP
            const AHKP = parseFloat(calculateIncidencesField(`incidences_annuite_hors_capital_porte_${yearIdx}`, yearIdx, updatedOperation)) || 0;
            updatedOperation[`incidences_annuite_hors_capital_porte_${yearIdx}`] = AHKP;
            
            // AT
            const AT = parseFloat(calculateIncidencesField(`incidences_annuite_definitive_${yearIdx}`, yearIdx, updatedOperation)) || 0;
            updatedOperation[`incidences_annuite_definitive_${yearIdx}`] = AT;
            
            // KS
            const KS = parseFloat(calculateIncidencesField(`incidences_capital_stocke_${yearIdx}`, yearIdx, updatedOperation)) || 0;
            updatedOperation[`incidences_capital_stocke_${yearIdx}`] = KS;
            
            // CFP
            const CFP = parseFloat(calculateIncidencesField(`incidences_calcul_frais_portage_${yearIdx}`, yearIdx, updatedOperation)) || 0;
            updatedOperation[`incidences_calcul_frais_portage_${yearIdx}`] = CFP;
            
            // FPHT
            const FPHT = parseFloat(calculateIncidencesField(`incidences_frais_portage_ht_${yearIdx}`, yearIdx, updatedOperation)) || 0;
            updatedOperation[`incidences_frais_portage_ht_${yearIdx}`] = FPHT;
            
            // TVA
            const TVA = parseFloat(calculateIncidencesField(`incidences_tva_frais_portage_${yearIdx}`, yearIdx, updatedOperation)) || 0;
            updatedOperation[`incidences_tva_frais_portage_${yearIdx}`] = TVA;
            
            // FPTTC
            const FPTTC = parseFloat(calculateIncidencesField(`incidences_frais_portage_ttc_${yearIdx}`, yearIdx, updatedOperation)) || 0;
            updatedOperation[`incidences_frais_portage_ttc_${yearIdx}`] = FPTTC;
            
            // TOTDEP
            const TOTDEP = parseFloat(calculateIncidencesField(`incidences_total_depenses_${yearIdx}`, yearIdx, updatedOperation)) || 0;
            updatedOperation[`incidences_total_depenses_${yearIdx}`] = TOTDEP;
            
            // TOTREC
            const TOTREC = parseFloat(calculateIncidencesField(`incidences_total_recettes_${yearIdx}`, yearIdx, updatedOperation)) || 0;
            updatedOperation[`incidences_total_recettes_${yearIdx}`] = TOTREC;
            
            // SAFG
            const SAFG = parseFloat(calculateIncidencesField(`incidences_solde_annuel_frais_gestion_${yearIdx}`, yearIdx, updatedOperation)) || 0;
            updatedOperation[`incidences_solde_annuel_frais_gestion_${yearIdx}`] = SAFG;
            
            // SCFG
            const SCFG = parseFloat(calculateIncidencesField(`incidences_solde_cumule_frais_gestion_${yearIdx}`, yearIdx, updatedOperation)) || 0;
            updatedOperation[`incidences_solde_cumule_frais_gestion_${yearIdx}`] = SCFG;
            
            // SO
            const SO = parseFloat(calculateIncidencesField(`incidences_solde_operation_${yearIdx}`, yearIdx, updatedOperation)) || 0;
            updatedOperation[`incidences_solde_operation_${yearIdx}`] = SO;
        }
        
        // Mettre à jour l'objet operation avec les valeurs calculées
        setOperation(updatedOperation);
    };

    const calculateIncidencesField = (field, yearIdx, operationData = null) => {
        const opData = operationData || operation;
        if (!opData) return '';
        
        const DP = parseFloat(opData.duree_portage) || 0;
        const DD = parseFloat(opData.duree_differe) || 0;
        
        // Calculer l'index de la première facturation (par rapport à l'année d'acquisition)
        let yearFirstFacturationIdx = 0;
        if (opData.date_premiere_acquisition && opData.date_premiere_facturation) {
            const yearAcquisition = new Date(opData.date_premiere_acquisition).getFullYear();
            const yearFirstFacturation = new Date(opData.date_premiere_facturation).getFullYear();
            yearFirstFacturationIdx = yearFirstFacturation - yearAcquisition;
        }
        
        // L'indice où commence l'amortissement (première facturation + 1 + différé)
        const ddStartIdx = yearFirstFacturationIdx + DD;
        
        // ST1 = A + F + SUB + RETRO
        if (field === `incidences_total_annuel_capital_porte_${yearIdx}`) {
            const A = parseFloat(opData[`incidences_prix_acquisition_${yearIdx}`]) || 0;
            const F = parseFloat(opData[`incidences_frais_actes_${yearIdx}`]) || 0;
            const SUB = parseFloat(opData[`incidences_subventions_${yearIdx}`]) || 0;
            const RETRO = parseFloat(opData[`incidences_montant_retrocessions_${yearIdx}`]) || 0;
            return A + F + SUB + RETRO;
        }
        
        // ST2 = FP + FA + GEGR + PROTO
        if (field === `incidences_total_annuel_hors_capital_porte_${yearIdx}`) {
            const FP = parseFloat(opData[`incidences_frais_prealables_${yearIdx}`]) || 0;
            const FA = parseFloat(opData[`incidences_frais_annexes_${yearIdx}`]) || 0;
            const GEGR = parseFloat(opData[`incidences_frais_gegr_${yearIdx}`]) || 0;
            const PROTO = parseFloat(opData[`incidences_frais_proto_amenagement_${yearIdx}`]) || 0;
            return FP + FA + GEGR + PROTO;
        }
        
        // AKP avec cumuls: commence après le différé depuis la première année du portage (à partir de yearFirstFacturationIdx + DD)
        if (field === `incidences_annuite_capital_porte_${yearIdx}`) {
            // Vérifier si AKP-REEL a une valeur - si oui, l'utiliser à la place
            const akpReelField = `incidences_annuite_capital_porte_reel_${yearIdx}`;
            const akpReelValue = parseFloat(opData[akpReelField]) || 0;
            if (akpReelValue !== 0) {
                return akpReelValue;
            }
            
            const akpStartIdx = yearFirstFacturationIdx + DD;
            if (yearIdx < akpStartIdx) {
                return 0;
            }
            
            // Calculer itérativement de akpStartIdx jusqu'à yearIdx avec cache local
            let akpCache = {};
            console.log(yearIdx)
            
            for (let y = akpStartIdx; y <= yearIdx; y++) {
                // Vérifier si AKP-REEL existe pour cette année
                const akpReelFieldY = `incidences_annuite_capital_porte_reel_${y}`;
                const akpReelValueY = parseFloat(opData[akpReelFieldY]) || 0;
                if (akpReelValueY !== 0) {
                    akpCache[y] = akpReelValueY;
                    continue;
                }
                
                if (y === akpStartIdx) {
                    // Première année: Somme des ST1 depuis le début jusqu'à y-1 (excluant l'année courante)
                    let cumulST1 = 0;
                    for (let i = 0; i < y; i++) {
                        cumulST1 += parseFloat(calculateIncidencesField(`incidences_total_annuel_capital_porte_${i}`, i, opData)) || 0;
                    }
                    // yearsToAmortize est le nombre d'années qu'il me reste à amortir
                    const totalYears = yearFirstFacturationIdx + DP;
                    const yearsToAmortize = totalYears - y;
                    akpCache[y] = yearsToAmortize > 0 ? cumulST1 / yearsToAmortize : 0;
                } else {
                    // Années suivantes: Somme de tous les ST1 depuis le début jusqu'à y-1 (excluant l'année courante)
                    let cumulST1 = 0;
                    for (let i = 0; i < y; i++) {
                        cumulST1 += parseFloat(calculateIncidencesField(`incidences_total_annuel_capital_porte_${i}`, i, opData)) || 0;
                    }
                    
                    // Cumul de AKP de akpStartIdx à y-1
                    let cumulAKP = 0;
                    for (let i = akpStartIdx; i < y; i++) {
                        cumulAKP += akpCache[i] || 0;
                    }
                    
                    const totalYears = yearFirstFacturationIdx + DP;
                    const yearsToAmortize = totalYears - y;
                    akpCache[y] = yearsToAmortize > 0 ? (cumulST1 - cumulAKP) / yearsToAmortize : 0;
                }
            }
            
            return akpCache[yearIdx] || 0;
        }
        
        // AHKP avec cumuls: commence après le différé depuis la première année du portage (à partir de yearFirstFacturationIdx + DD)
        if (field === `incidences_annuite_hors_capital_porte_${yearIdx}`) {
            // Vérifier si AHKP-REEL a une valeur - si oui, l'utiliser à la place
            const ahkpReelField = `incidences_annuite_hors_capital_porte_reel_${yearIdx}`;
            const ahkpReelValue = parseFloat(opData[ahkpReelField]) || 0;
            if (ahkpReelValue !== 0) {
                return ahkpReelValue;
            }
            
            const akpStartIdx = yearFirstFacturationIdx + DD;
            if (yearIdx < akpStartIdx) {
                return 0;
            }
            
            // Calculer itérativement de akpStartIdx jusqu'à yearIdx avec cache local
            let ahkpCache = {};
            
            for (let y = akpStartIdx; y <= yearIdx; y++) {
                // Vérifier si AHKP-REEL existe pour cette année
                const ahkpReelFieldY = `incidences_annuite_hors_capital_porte_reel_${y}`;
                const ahkpReelValueY = parseFloat(opData[ahkpReelFieldY]) || 0;
                if (ahkpReelValueY !== 0) {
                    ahkpCache[y] = ahkpReelValueY;
                    continue;
                }
                
                if (y === akpStartIdx) {
                    // Première année: Somme des ST2 depuis le début jusqu'à y-1 (excluant l'année courante)
                    let cumulST2 = 0;
                    for (let i = 0; i < y; i++) {
                        cumulST2 += parseFloat(calculateIncidencesField(`incidences_total_annuel_hors_capital_porte_${i}`, i, opData)) || 0;
                    }
                    const totalYears = yearFirstFacturationIdx + DP;
                    const yearsToAmortize = totalYears - y;
                    ahkpCache[y] = yearsToAmortize > 0 ? cumulST2 / yearsToAmortize : 0;
                } else {
                    // Années suivantes: Somme de tous les ST2 depuis le début jusqu'à y-1 (excluant l'année courante)
                    let cumulST2 = 0;
                    for (let i = 0; i < y; i++) {
                        cumulST2 += parseFloat(calculateIncidencesField(`incidences_total_annuel_hors_capital_porte_${i}`, i, opData)) || 0;
                    }
                    
                    // Cumul de AHKP de akpStartIdx à y-1
                    let cumulAHKP = 0;
                    for (let i = akpStartIdx; i < y; i++) {
                        cumulAHKP += ahkpCache[i] || 0;
                    }
                    
                    const totalYears = yearFirstFacturationIdx + DP;
                    const yearsToAmortize = totalYears - y;
                    ahkpCache[y] = yearsToAmortize > 0 ? (cumulST2 - cumulAHKP) / yearsToAmortize : 0;
                }
            }
            
            return ahkpCache[yearIdx] || 0;
        }
        
        // AT = AKP + AHKP (sans AJ)
        if (field === `incidences_annuite_definitive_${yearIdx}`) {
            const AKP = parseFloat(calculateIncidencesField(`incidences_annuite_capital_porte_${yearIdx}`, yearIdx, opData)) || 0;
            const AHKP = parseFloat(calculateIncidencesField(`incidences_annuite_hors_capital_porte_${yearIdx}`, yearIdx, opData)) || 0;
            return AKP + AHKP;
        }
        
        // KS = Somme(ST1) + Somme(ST2) - Somme(AT) jusqu'à l'année courante (incluse)
        if (field === `incidences_capital_stocke_${yearIdx}`) {
            let cumulST1 = 0;
            let cumulST2 = 0;
            let cumulAT = 0;
            for (let i = 0; i <= yearIdx; i++) {
                cumulST1 += parseFloat(calculateIncidencesField(`incidences_total_annuel_capital_porte_${i}`, i, opData)) || 0;
                cumulST2 += parseFloat(calculateIncidencesField(`incidences_total_annuel_hors_capital_porte_${i}`, i, opData)) || 0;
                cumulAT += parseFloat(calculateIncidencesField(`incidences_annuite_definitive_${i}`, i, opData)) || 0;
            }
            return cumulST1 + cumulST2 - cumulAT;
        }
        
        // CFP = cumul de (ST1 - AKP) - sans AJ
        if (field === `incidences_calcul_frais_portage_${yearIdx}`) {
            let cumulCFP = 0;
            for (let i = 0; i <= yearIdx; i++) {
                const ST1 = parseFloat(calculateIncidencesField(`incidences_total_annuel_capital_porte_${i}`, i, opData)) || 0;
                const AKP = parseFloat(calculateIncidencesField(`incidences_annuite_capital_porte_${i}`, i, opData)) || 0;
                cumulCFP += ST1 - AKP;
            }
            return cumulCFP;
        }
        
        // FPHT = (Taux frais / 100) * CFP(n-1)
        if (field === `incidences_frais_portage_ht_${yearIdx}`) {
            // Vérifier si un Taux spécifique existe pour cette année
            let tauxFrais = (opData.taux_frais_modalite !== undefined && opData.taux_frais_modalite !== null) 
                ? parseFloat(opData.taux_frais_modalite) 
                : parseFloat(opData.taux_frais_gestion) || 0;
            const tauxAnnuelField = `incidences_taux_${yearIdx}`;
            const tauxAnnuel = parseFloat(opData[tauxAnnuelField]);
            if (tauxAnnuel !== null && tauxAnnuel !== undefined && !isNaN(tauxAnnuel) && tauxAnnuel !== 0) {
                tauxFrais = tauxAnnuel;
            }
            
            let CFP_prev = 0;
            if (yearIdx > 0) {
                CFP_prev = parseFloat(calculateIncidencesField(`incidences_calcul_frais_portage_${yearIdx - 1}`, yearIdx - 1, opData)) || 0;
            }
            return (tauxFrais / 100) * CFP_prev;
        }
        
        // TVA = FPHT * 0.2
        if (field === `incidences_tva_frais_portage_${yearIdx}`) {
            const FPHT = parseFloat(calculateIncidencesField(`incidences_frais_portage_ht_${yearIdx}`, yearIdx, opData)) || 0;
            return FPHT * 0.2;
        }
        
        // FPTTC = FPHT + TVA
        if (field === `incidences_frais_portage_ttc_${yearIdx}`) {
            const FPHT = parseFloat(calculateIncidencesField(`incidences_frais_portage_ht_${yearIdx}`, yearIdx, opData)) || 0;
            const TVA = parseFloat(calculateIncidencesField(`incidences_tva_frais_portage_${yearIdx}`, yearIdx, opData)) || 0;
            return FPHT + TVA;
        }
        
        // TOTDEP = ER + DEE + DCC + DTFB + DOM + DASS + DAU
        if (field === `incidences_total_depenses_${yearIdx}`) {
            const ER = parseFloat(opData[`incidences_entretien_reparations_${yearIdx}`]) || 0;
            const DEE = parseFloat(opData[`incidences_eau_electricite_${yearIdx}`]) || 0;
            const DCC = parseFloat(opData[`incidences_charges_copropriete_${yearIdx}`]) || 0;
            const DTFB = parseFloat(opData[`incidences_taxes_foncieres_${yearIdx}`]) || 0;
            const DOM = parseFloat(opData[`incidences_taxe_redevance_om_${yearIdx}`]) || 0;
            const DASS = parseFloat(opData[`incidences_assurances_${yearIdx}`]) || 0;
            const DAU = parseFloat(opData[`incidences_autres_depenses_${yearIdx}`]) || 0;
            return ER + DEE + DCC + DTFB + DOM + DASS + DAU;
        }
        
        // TOTREC = LOY + REE + RCC + RTFB + ROM + RASS + RAU
        if (field === `incidences_total_recettes_${yearIdx}`) {
            const LOY = parseFloat(opData[`incidences_loyers_percus_${yearIdx}`]) || 0;
            const REE = parseFloat(opData[`incidences_refacturation_eau_electricite_${yearIdx}`]) || 0;
            const RCC = parseFloat(opData[`incidences_refacturation_charges_copropriete_${yearIdx}`]) || 0;
            const RTFB = parseFloat(opData[`incidences_refacturation_taxes_foncieres_${yearIdx}`]) || 0;
            const ROM = parseFloat(opData[`incidences_refacturation_om_${yearIdx}`]) || 0;
            const RASS = parseFloat(opData[`incidences_refacturation_assurances_${yearIdx}`]) || 0;
            const RAU = parseFloat(opData[`incidences_autres_recettes_${yearIdx}`]) || 0;
            return LOY + REE + RCC + RTFB + ROM + RASS + RAU;
        }
        
        // SAFG = TOTREC - TOTDEP
        if (field === `incidences_solde_annuel_frais_gestion_${yearIdx}`) {
            const TOTDEP = parseFloat(calculateIncidencesField(`incidences_total_depenses_${yearIdx}`, yearIdx, opData)) || 0;
            const TOTREC = parseFloat(calculateIncidencesField(`incidences_total_recettes_${yearIdx}`, yearIdx, opData)) || 0;
            return TOTREC - TOTDEP;
        }
        
        // SCFG = SCFG(n-1) + SAFG
        if (field === `incidences_solde_cumule_frais_gestion_${yearIdx}`) {
            let SCFG_prev = 0;
            if (yearIdx > 0) {
                SCFG_prev = parseFloat(calculateIncidencesField(`incidences_solde_cumule_frais_gestion_${yearIdx - 1}`, yearIdx - 1, opData)) || 0;
            }
            const SAFG = parseFloat(calculateIncidencesField(`incidences_solde_annuel_frais_gestion_${yearIdx}`, yearIdx, opData)) || 0;
            return SCFG_prev + SAFG;
        }
        
        // SO = KS - SCFG
        if (field === `incidences_solde_operation_${yearIdx}`) {
            const KS = parseFloat(calculateIncidencesField(`incidences_capital_stocke_${yearIdx}`, yearIdx, opData)) || 0;
            const SCFG = parseFloat(calculateIncidencesField(`incidences_solde_cumule_frais_gestion_${yearIdx}`, yearIdx, opData)) || 0;
            return KS - SCFG;
        }
        
        return 0;
    };

    // Mettre à jour automatiquement le taux frais quand la modalité de portage change
    useEffect(() => {
        if (operation && operation.id_modalite_portage && modalites.length > 0) {
            const selectedModalite = modalites.find(m => m.id === operation.id_modalite_portage);
            if (selectedModalite && selectedModalite.taux) {
                updateField('taux_frais_gestion', selectedModalite.taux);
            }
            // Stocker la modalité sélectionnée
            setModalite_portage_selectionnee(selectedModalite || null);
        }
    }, [operation?.id_modalite_portage, modalites]);

    return (
        <div>
            <Access needConnection={true} type_user={[0,1,2]}>
                <Navbar user={props.user} />

                <div style={{display: 'flex'}}>
                    <div style={{flex: 1, margin: 20, display: 'flex'}}>
                        <div style={{flex: 1, display: 'flex'}}>
                            <p>Opération {operation?.numero_inventaire || ''} :</p>
                            <p style={{marginLeft: 5, color: purple, fontWeight: 'bold'}}>{operation?.nom || ''}</p>
                        </div>
                        <div>
                            {props.user?
                            <p style={{flex: 1, textAlign: 'center'}}>{props.user.nom_budget}</p>
                            :null}
                        </div>
                        <div style={{flex: 1}}></div>
                    </div>
                </div>

                <div style={{flex: 1, textAlign: 'center'}}>
                    {operation?
                    <div style={{marginBottom: 100, marginRight: 100, marginLeft: 100}}>

                        <Dialog
                            setModalVisible={setDialogModalVisible}
                            modalVisible={dialogModalVisible}
                            callbackDialog={callbackDialog}
                            message={"Confirmez la suppression"}
                        />

                        <ModalPilotage
                            modalVisible={modalPilotage}
                            setModalVisible={setModalPilotage}
                            objet={objetPilotage}
                            user={props.user}
                        />

                        <div style={{display: 'flex', marginBottom: 20}}>

                            <button
                            style={operation.color === green?{border: '2px solid '+green, borderRadius: 100, minWidth: 50, backgroundColor: green}:{border: '2px solid '+green, borderRadius: 100, minWidth: 50, backgroundColor: 'white'}}
                            onClick={() => {
                                if (operation.color === green) {
                                    updateField('color', null);
                                } else {
                                    updateField('color', green);
                                }
                            }}
                            >
                            </button>

                            <button
                            style={operation.color === orange?{marginLeft: 20, border: '2px solid '+orange, borderRadius: 100, minWidth: 50, backgroundColor: orange}:{marginLeft: 20, border: '2px solid '+orange, borderRadius: 100, minWidth: 50, backgroundColor: 'white'}}
                            onClick={() => {
                                if (operation.color === orange) {
                                    updateField('color', null);
                                } else {
                                    updateField('color', orange);
                                }
                            }}
                            >
                            </button>

                            <button
                            style={operation.color === red?{marginLeft: 20, border: '2px solid '+red, borderRadius: 100, minWidth: 50, backgroundColor: red}:{marginLeft: 20, border: '2px solid '+red, borderRadius: 100, minWidth: 50, backgroundColor: 'white'}}
                            onClick={() => {
                                if (operation.color === red) {
                                    updateField('color', null);
                                } else {
                                    updateField('color', red);
                                }
                            }}
                            >
                            </button>
                            
                            <div style={{flex: 1}}></div>

                            <button
                                className='shadow-md p-2 rounded-md'
                                style={details?{backgroundColor: purple, color: 'white', fontSize: 17, margin: 5}:{backgroundColor: 'white', color: purple, fontSize: 17, margin: 5, border: '1px solid '+purple}}
                                onClick={() => {
                                    setDetails(true);
                                    setMoyens(false);
                                    setEcheancier(false);
                                    setIncidences(false);
                                    setEvaluation(false);
                                    setPilotage(false);
                                }}
                            >
                                Données générales
                            </button>

                            <button
                                className='shadow-md p-2 rounded-md'
                                style={moyens?{backgroundColor: purple, color: 'white', fontSize: 17, margin: 5}:{backgroundColor: 'white', color: purple, fontSize: 17, margin: 5, border: '1px solid '+purple}}
                                onClick={() => {
                                    setDetails(false);
                                    setMoyens(true);
                                    setEcheancier(false);
                                    setIncidences(false);
                                    setEvaluation(false);
                                    setPilotage(false);
                                }}
                            >
                                Moyens mis en œuvre
                            </button>

                            <button
                                className='shadow-md p-2 rounded-md'
                                style={echeancier?{backgroundColor: purple, color: 'white', fontSize: 17, margin: 5}:{backgroundColor: 'white', color: purple, fontSize: 17, margin: 5, border: '1px solid '+purple}}
                                onClick={() => {
                                    setDetails(false);
                                    setMoyens(false);
                                    setEcheancier(true);
                                    setIncidences(false);
                                    setEvaluation(false);
                                    setPilotage(false);
                                }}
                            >
                                Échéancier
                            </button>

                            <button
                                className='shadow-md p-2 rounded-md'
                                style={incidences?{backgroundColor: purple, color: 'white', fontSize: 17, margin: 5}:{backgroundColor: 'white', color: purple, fontSize: 17, margin: 5, border: '1px solid '+purple}}
                                onClick={() => {
                                    setDetails(false);
                                    setMoyens(false);
                                    setEcheancier(false);
                                    setIncidences(true);
                                    setEvaluation(false);
                                    setPilotage(false);
                                    recalculateAllTableFields();
                                }}
                            >
                                Incidences Financières
                            </button>

                            <button
                                className='shadow-md p-2 rounded-md'
                                style={evaluation?{backgroundColor: purple, color: 'white', fontSize: 17, margin: 5}:{backgroundColor: 'white', color: purple, fontSize: 17, margin: 5, border: '1px solid '+purple}}
                                onClick={() => {
                                    setDetails(false);
                                    setMoyens(false);
                                    setEcheancier(false);
                                    setIncidences(false);
                                    setEvaluation(true);
                                    setPilotage(false);
                                }}
                            >
                                Évaluation
                            </button>

                            <button
                                className='shadow-md p-2 rounded-md'
                                style={pilotage?{backgroundColor: purple, color: 'white', fontSize: 17, margin: 5}:{backgroundColor: 'white', color: purple, fontSize: 17, margin: 5, border: '1px solid '+purple}}
                                onClick={() => {
                                    setDetails(false);
                                    setMoyens(false);
                                    setEcheancier(false);
                                    setEvaluation(false);
                                    setPilotage(true);
                                }}
                            >
                                Pilotage
                            </button>

                            <div style={{flex: 1}}></div>
                            
                            <button
                                className='shadow-md rounded-md'
                                style={{backgroundColor: green, color: 'white', fontSize: 17, alignItems: 'center', justifyContent: 'center', display: 'flex', paddingLeft: 10, paddingRight: 10}}
                                onClick={async () => {
                                    const success = await valider();
                                    if (success) {
                                        // setTimeout(() => {history.push('/operations?timestamp=' + new Date().getTime())}, 1000);
                                    }
                                }}
                            >
                                <Check width="12" />
                                <p style={{marginLeft: 10}}>Valider</p>
                            </button>

                        </div>

                        {/****************************** Données générales ********************************/}
                        {details?
                        <div>

                            {/* Ligne 1: Intitulé + Numéro d'inventaire */}
                            <div style={{display: 'flex', gap: 10, marginBottom: 10}}>
                                <div style={{display: 'flex', flex: 4}} className='shadow-md rounded-md'>
                                    <div style={{display: 'flex', alignItems: 'center', padding: 10, backgroundColor: greyChapter, width: 300}}>
                                        <p style={{margin: 0}}>Intitulé</p>
                                    </div>
                                    <div style={{display: 'flex', flex: 1}}>
                                    <input
                                        style={{ flex: 1, padding: 8, fontSize: 15, border: 'none', outline: 'none' }}
                                        onChange={(e) => updateField('nom', e.target.value)}
                                        value={operation.nom || ''}
                                    />
                                    </div>
                                </div>

                                <div style={{flex: 1}} className='shadow-md rounded-md'>
                                    <div style={{width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 10, backgroundColor: greyChapter}}>
                                        <p style={{}}>N° inventaire</p>
                                    </div>
                                    <input
                                        style={{ width: '100%', padding: 8, fontSize: 15, border: 'none', outline: 'none' }}
                                        onChange={(e) => updateField('numero_inventaire', e.target.value)}
                                        value={operation.numero_inventaire || ''}
                                    />
                                </div>
                            </div>

                            {/* Ligne 3: Montant */}
                            <div style={{display: 'flex', gap: 10, marginBottom: 10}}>
                                <div style={{display: 'flex', flex: 1}} className='shadow-md rounded-md'>
                                    <div style={{display: 'flex', alignItems: 'center', padding: 10, backgroundColor: greyChapter, width: 300}}>
                                        <p style={{margin: 0}}>Montant (€ TTC)</p>
                                    </div>
                                    <div style={{display: 'flex', flex: 1, alignItems: 'center'}}>
                                    <input
                                        type="text"
                                        style={{ flex: 1, padding: 8, fontSize: 15, border: 'none', outline: 'none' }}
                                        onBlur={async (e) => {
                                            if (e.target.value !== '' && (parseFloat(e.target.value) || e.target.value === '0')) {
                                                const cleanValue = (Math.round(parseFloat(e.target.value) * 100) / 100).toString().replace(',', '.').replace('€', '').replace(' ', '').replace("'", '').replace('"', '');
                                                updateField('montant', cleanValue);
                                                if (!e.target.value.includes('€')) {
                                                    e.target.value = addSpace((Math.round(parseFloat(e.target.value) * 100) / 100).toString().replace("'", '').replace('"', ''))+'€';
                                                }
                                                await setAff(!aff);
                                            }
                                            e.target.value = '';
                                        }}
                                        placeholder={operation.montant !== null && operation.montant !== '' ? addSpace(parseFloat(operation.montant))+'€' : '0€'}
                                    />
                                    </div>
                                </div>
                            </div>

                            {/* Ligne 2: Client + Axe + Modalité */}
                            <div style={{display: 'flex', gap: 10, marginBottom: 50}}>
                                <div style={{flex: 1}} className='shadow-md rounded-md'>
                                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 10, backgroundColor: greyChapter}}>
                                        <p style={{margin: 0}}>Collectivités</p>
                                    </div>
                                    <select
                                        style={{ width: '100%', padding: 8, fontSize: 14, border: 'none', outline: 'none' }}
                                        onChange={(e) => updateField('id_clients_epfl', e.target.value ? parseInt(e.target.value) : '')}
                                        value={operation.id_clients_epfl || ''}
                                    >
                                        <option value=''>-- Aucun --</option>
                                        {clients.map(c => (
                                            <option key={c.id} value={c.id}>{c.nom}</option>
                                        ))}
                                    </select>
                                </div>

                                <div style={{flex: 1}} className='shadow-md rounded-md'>
                                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 10, backgroundColor: greyChapter}}>
                                        <p style={{margin: 0}}>Axe d'intervention</p>
                                    </div>
                                    <select
                                        style={{ width: '100%', padding: 8, fontSize: 14, border: 'none', outline: 'none' }}
                                        onChange={(e) => updateField('id_axes_interventions', e.target.value ? parseInt(e.target.value) : '')}
                                        value={operation.id_axes_interventions || ''}
                                    >
                                        <option value=''>-- Aucun --</option>
                                        {axes.map(a => (
                                            <option key={a.id} value={a.id}>{a.intitule}</option>
                                        ))}
                                    </select>
                                </div>

                                <div style={{flex: 1}} className='shadow-md rounded-md'>
                                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 10, backgroundColor: greyChapter}}>
                                        <p style={{margin: 0}}>Modalités de portage</p>
                                    </div>
                                    <select
                                        style={{ width: '100%', padding: 8, fontSize: 14, border: 'none', outline: 'none' }}
                                        onChange={(e) => updateField('id_modalite_portage', e.target.value ? parseInt(e.target.value) : '')}
                                        value={operation.id_modalite_portage || ''}
                                    >
                                        <option value=''>-- Aucune --</option>
                                        {modalites.map(m => (
                                            <option key={m.id} value={m.id}>{m.intitule}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                            {/* Ligne 9: Dates */}
                            <div style={{display: 'flex', gap: 10, marginBottom: 10}}>
                                <div style={{flex: 1}} className='shadow-md rounded-md'>
                                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 10, backgroundColor: greyChapter}}>
                                        <p style={{margin: 0}}>Date de 1ère acquisition</p>
                                    </div>
                                    <input
                                        type="date"
                                        style={{ width: '100%', textAlign: 'center', padding: 8, fontSize: 14, border: 'none', outline: 'none' }}
                                        onChange={(e) => updateField('date_premiere_acquisition', e.target.value)}
                                        value={operation.date_premiere_acquisition || ''}
                                    />
                                </div>

                                <div style={{flex: 1}} className='shadow-md rounded-md'>
                                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 10, backgroundColor: greyChapter}}>
                                        <p style={{margin: 0}}>Date de 1ère facturation</p>
                                    </div>
                                    <input
                                        type="date"
                                        style={{ width: '100%', textAlign: 'center', padding: 8, fontSize: 14, border: 'none', outline: 'none' }}
                                        onChange={(e) => updateField('date_premiere_facturation', e.target.value)}
                                        value={operation.date_premiere_facturation || ''}
                                    />
                                </div>
                            </div>

                            {/* Ligne 10: Durées */}
                            <div style={{display: 'flex', gap: 10, marginBottom: 50}}>
                                <div style={{flex: 1}} className='shadow-md rounded-md'>
                                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 10, backgroundColor: greyChapter}}>
                                        <p style={{margin: 0}}>Durée de portage (en années)</p>
                                    </div>
                                    <input
                                        type="number"
                                        style={{ width: '100%', textAlign: 'center', padding: 8, fontSize: 14, border: 'none', outline: 'none' }}
                                        onChange={(e) => {
                                            if (e.target.value >= 0) {
                                                updateField('duree_portage', e.target.value);
                                            }
                                            else {
                                                updateField('duree_portage', 0);
                                            }
                                        }}
                                        value={operation.duree_portage || ''}
                                    />
                                </div>

                                <div style={{flex: 1}} className='shadow-md rounded-md'>
                                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 10, backgroundColor: greyChapter}}>
                                        <p style={{margin: 0}}>Durée de différé (en années)</p>
                                    </div>
                                    <input
                                        type="number"
                                        style={{ width: '100%', textAlign: 'center', padding: 8, fontSize: 14, border: 'none', outline: 'none' }}
                                        onChange={(e) => {
                                            if (e.target.value >= 0) {
                                                updateField('duree_differe', e.target.value);
                                            }
                                            else {
                                                updateField('duree_differe', 0);
                                            }
                                        }}
                                        value={operation.duree_differe !== undefined && operation.duree_differe !== null ? operation.duree_differe : 0}
                                    />
                                </div>
                            </div>

                            {/* Ligne 4: Description */}
                            <div style={{display: 'flex', marginBottom: 10}} className='shadow-md rounded-md'>
                                <div style={{display: 'flex', alignItems: 'center', padding: 10, backgroundColor: greyChapter, width: 300}}>
                                    <p style={{margin: 0}}>Description</p>
                                </div>
                                <div style={{display: 'flex', flex: 1}}>
                                <textarea
                                    rows={4}
                                    style={{ flex: 1, padding: 8, fontSize: 14, resize: 'vertical', border: 'none', outline: 'none' }}
                                    onChange={(e) => updateField('description', e.target.value)}
                                    value={operation.description || ''}
                                />
                                </div>
                            </div>

                            <div style={{display: 'flex', marginBottom: 10}} className='shadow-md rounded-md'>
                                <div style={{display: 'flex', alignItems: 'center', padding: 10, backgroundColor: greyChapter, width: 300}}>
                                    <p style={{margin: 0}}>Enjeu</p>
                                </div>
                                <div style={{display: 'flex', flex: 1}}>
                                <textarea
                                    rows={4}
                                    style={{ flex: 1, padding: 8, fontSize: 14, resize: 'vertical', border: 'none', outline: 'none' }}
                                    onChange={(e) => updateField('enjeu', e.target.value)}
                                    value={operation.enjeu || ''}
                                />
                                </div>
                            </div>

                            {/* Ligne 11: Prérequis */}
                            <div style={{display: 'flex', marginBottom: 10}} className='shadow-md rounded-md'>
                                <div style={{display: 'flex', alignItems: 'center', padding: 10, backgroundColor: greyChapter, width: 300}}>
                                    <p style={{margin: 0}}>Prérequis de mise en œuvre</p>
                                </div>
                                <div style={{display: 'flex', flex: 1}}>
                                <textarea
                                    rows={3}
                                    style={{ flex: 1, padding: 8, fontSize: 14, resize: 'vertical', border: 'none', outline: 'none' }}
                                    onChange={(e) => updateField('prerequis_mise_en_oeuvre', e.target.value)}
                                    value={operation.prerequis_mise_en_oeuvre || ''}
                                />
                                </div>
                            </div>

                            {/* Ligne 12: Questions */}
                            <div style={{display: 'flex', marginBottom: 10}} className='shadow-md rounded-md'>
                                <div style={{display: 'flex', alignItems: 'center', padding: 10, backgroundColor: greyChapter, width: 300}}>
                                    <p style={{margin: 0}}>Questions / Remarques</p>
                                </div>
                                <div style={{display: 'flex', flex: 1}}>
                                <textarea
                                    rows={3}
                                    style={{ flex: 1, padding: 8, fontSize: 14, resize: 'vertical', border: 'none', outline: 'none' }}
                                    onChange={(e) => updateField('questions', e.target.value)}
                                    value={operation.questions || ''}
                                />
                                </div>
                            </div>

                            {/* Ligne 13: Partenaires à mobiliser */}
                            <div style={{display: 'flex', gap: 10, marginBottom: 50}}>
                                <div style={{display: 'flex', flex: 1}} className='shadow-md rounded-md'>
                                    <div style={{display: 'flex', alignItems: 'center', padding: 10, backgroundColor: greyChapter, width: 300, flexDirection: 'column'}}>
                                        <p style={{margin: 0}}>Partenaires à mobiliser</p>
                                        <p style={{margin: '5px 0 0 0', fontSize: 12, color: '#666', textAlign: 'center'}}>{(operation.partenaires || '').length}/255</p>
                                    </div>
                                    <div style={{display: 'flex', flex: 1}}>
                                    <textarea
                                        rows={2}
                                        maxLength={255}
                                        style={{ flex: 1, padding: 8, fontSize: 14, resize: 'vertical', border: 'none', outline: 'none' }}
                                        onChange={(e) => updateField('partenaires', e.target.value)}
                                        value={operation.partenaires || ''}
                                    />
                                    </div>
                                </div>
                            </div>

                            {/* Ligne 5: Gestionnaires */}
                            {/* <div style={{display: 'flex', gap: 10, marginBottom: 10}}>
                                <div style={{display: 'flex', flex: 1}} className='shadow-md rounded-md'>
                                    <div style={{display: 'flex', alignItems: 'center', padding: 10, backgroundColor: greyChapter, width: 300}}>
                                        <p style={{margin: 0}}>Gestionnaire</p>
                                    </div>
                                    <div style={{display: 'flex', flex: 1}}>
                                    <input
                                        style={{ flex: 1, padding: 8, fontSize: 14, border: 'none', outline: 'none' }}
                                        onChange={(e) => updateField('gestionnaire', e.target.value)}
                                        value={operation.gestionnaire || ''}
                                    />
                                    </div>
                                </div>
                            </div> */}

                            <div style={{display: 'flex', gap: 10, marginBottom: 10}}>
                                <div style={{display: 'flex', flex: 1}} className='shadow-md rounded-md'>
                                    <div style={{display: 'flex', alignItems: 'center', padding: 10, backgroundColor: greyChapter, width: 300}}>
                                        <p style={{margin: 0}}>Gestionnaire interne</p>
                                    </div>
                                    <div style={{display: 'flex', flex: 1}}>
                                    <input
                                        style={{ flex: 1, padding: 8, fontSize: 14, border: 'none', outline: 'none' }}
                                        onChange={(e) => updateField('gestionnaire_interne', e.target.value)}
                                        value={operation.gestionnaire_interne || ''}
                                    />
                                    </div>
                                </div>
                            </div>

                            {/* Ligne 6: Service référent + Partenaires */}
                            <div style={{display: 'flex', gap: 10, marginBottom: 10}}>
                                <div style={{display: 'flex', flex: 1}} className='shadow-md rounded-md'>
                                    <div style={{display: 'flex', alignItems: 'center', padding: 10, backgroundColor: greyChapter, width: 300}}>
                                        <p style={{margin: 0}}>Service référent</p>
                                    </div>
                                    <div style={{display: 'flex', flex: 1}}>
                                    <input
                                        style={{ flex: 1, padding: 8, fontSize: 14, border: 'none', outline: 'none' }}
                                        onChange={(e) => updateField('service_referent', e.target.value)}
                                        value={operation.service_referent || ''}
                                    />
                                    </div>
                                </div>

                            </div>

                            {/* Ligne 7: Technicien référent */}
                            <div style={{display: 'flex', gap: 10, marginBottom: 10}} className='shadow-md rounded-md'>
                                <div style={{display: 'flex', alignItems: 'center', padding: 10, backgroundColor: greyChapter, width: 300}}>
                                    <p style={{margin: 0}}>Technicien référent</p>
                                </div>
                                <div style={{display: 'flex', flex: 1}}>

                                    <div style={{flex: 1, padding: 5}}>
                                        <div style={{display: 'flex'}}>
                                            <input
                                            className='shadow-md rounded-md'
                                            style={{flex: 1, padding: 5, textAlign: 'center'}}
                                            onChange={(e) => {
                                                updateField('technicien_nom', e.target.value);
                                            }}
                                            onBlur={() => {
                                                const trimmed = operation.technicien_nom ? operation.technicien_nom.trim().replace(/\s+/g, ' ') : '';
                                                updateField('technicien_nom', trimmed);
                                            }}
                                            value={operation.technicien_nom === null ? "" : rescueHtml(operation.technicien_nom)}
                                            placeholder='Nom'
                                            />
                                        </div>
                                    </div>

                                    <div style={{flex: 1, padding: 5}}>
                                        <div style={{display: 'flex'}}>
                                            <input
                                            className='shadow-md rounded-md'
                                            style={{flex: 1, padding: 5, textAlign: 'center'}}
                                            type="email"
                                            onChange={(e) => {
                                                updateField('technicien_mail', e.target.value);
                                            }}
                                            onBlur={() => {
                                                const trimmed = operation.technicien_mail ? operation.technicien_mail.trim().replace(/\s+/g, '') : '';
                                                updateField('technicien_mail', trimmed);
                                            }}
                                            value={operation.technicien_mail === null ? "" : rescueHtml(operation.technicien_mail)}
                                            placeholder='Email'
                                            />
                                        </div>
                                    </div>
                                    <div style={{padding: 5}}>
                                        <input
                                        className='shadow-md rounded-md'
                                        type="tel"
                                        style={{padding: 5, textAlign: 'center'}}
                                        onChange={(e) => {
                                            // Format: ajouter un espace tous les 2 chiffres
                                            let value = e.target.value.replace(/\s/g, '');
                                            let formatted = value.match(/.{1,2}/g)?.join('') || value;
                                            updateField('technicien_telephone', formatted);
                                        }}
                                        onBlur={() => {
                                            const trimmed = operation.technicien_telephone ? operation.technicien_telephone.trim() : '';
                                            updateField('technicien_telephone', trimmed);
                                        }}
                                        value={operation.technicien_telephone === null ? "" : rescueHtml(operation.technicien_telephone).replace(/\s/g, '').match(/.{1,2}/g)?.join(' ') || rescueHtml(operation.technicien_telephone)}
                                        placeholder='Téléphone'
                                        />
                                    </div>
                                </div>
                            </div>
                            {/****/}

                            {/* Ligne 8: Fonction technicien référent */}
                            <div style={{display: 'flex', marginBottom: 50}} className='shadow-md rounded-md'>
                                <div style={{display: 'flex', alignItems: 'center', padding: 10, backgroundColor: greyChapter, width: 300}}>
                                    <p style={{margin: 0}}>Fonction technicien référent</p>
                                </div>
                                <div style={{display: 'flex', flex: 1}}>
                                    <input
                                    style={{flex: 1, padding: 5}}
                                    onChange={(e) => {
                                        updateField('technicien_fonction', e.target.value);
                                    }}
                                    onBlur={() => {
                                        const trimmed = operation.technicien_fonction ? operation.technicien_fonction.trim().replace(/\s+/g, ' ') : '';
                                        updateField('technicien_fonction', trimmed);
                                    }}
                                    value={operation.technicien_fonction === null ? "" : rescueHtml(operation.technicien_fonction)}
                                    />
                                </div>
                            </div>
                            {/****/}

                        </div>
                        :null}

                        {/****************************** Moyens mis en œuvre ********************************/}
                        {moyens?
                        <div>

                            {/* Ressources humaines */}
                            <div style={{display: 'flex', margin: 10}} className='shadow-md rounded-md'>
                                <div style={{flex: 0.3, padding: 10, backgroundColor: greyChapter, alignItems: 'center', minWidth: 175, display: 'flex', flexDirection: 'column'}}>
                                    <p>Ressources humaines</p>
                                    <p style={{margin: '5px 0 0 0', fontSize: 12, color: '#666', textAlign: 'center'}}>{(operation.ressources_humaines || '').length}/255</p>
                                </div>
                                <div style={{display: 'flex', flex: 1, flexDirection: 'column'}}>
                                <textarea
                                    rows={5}
                                    maxLength={255}
                                    style={{ flex: 1, padding: 5 }}
                                    onChange={(e) => updateField('ressources_humaines', e.target.value)}
                                    value={operation.ressources_humaines || ''}
                                />
                                </div>
                            </div>

                            {/* Études */}
                            <div style={{display: 'flex', margin: 10}} className='shadow-md rounded-md'>
                                <div style={{flex: 0.3, padding: 10, backgroundColor: greyChapter, alignItems: 'center', minWidth: 175, display: 'flex', flexDirection: 'column'}}>
                                    <p>Études</p>
                                    <p style={{margin: '5px 0 0 0', fontSize: 12, color: '#666', textAlign: 'center'}}>{(operation.etudes || '').length}/255</p>
                                </div>
                                <div style={{display: 'flex', flex: 1, flexDirection: 'column'}}>
                                <textarea
                                    rows={5}
                                    maxLength={255}
                                    style={{ flex: 1, padding: 5 }}
                                    onChange={(e) => updateField('etudes', e.target.value)}
                                    value={operation.etudes || ''}
                                />
                                </div>
                            </div>

                            {/* Outils */}
                            <div style={{display: 'flex', margin: 10}} className='shadow-md rounded-md'>
                                <div style={{flex: 0.3, padding: 10, backgroundColor: greyChapter, alignItems: 'center', minWidth: 175, display: 'flex', flexDirection: 'column'}}>
                                    <p>Outils</p>
                                    <p style={{margin: '5px 0 0 0', fontSize: 12, color: '#666', textAlign: 'center'}}>{(operation.outils || '').length}/255</p>
                                </div>
                                <div style={{display: 'flex', flex: 1, flexDirection: 'column'}}>
                                <textarea
                                    rows={5}
                                    maxLength={255}
                                    style={{ flex: 1, padding: 5 }}
                                    onChange={(e) => updateField('outils', e.target.value)}
                                    value={operation.outils || ''}
                                />
                                </div>
                            </div>

                            {/* Investissements */}
                            <div style={{display: 'flex', margin: 10}} className='shadow-md rounded-md'>
                                <div style={{flex: 0.3, padding: 10, backgroundColor: greyChapter, alignItems: 'center', minWidth: 175, display: 'flex', flexDirection: 'column'}}>
                                    <p>Investissements</p>
                                    <p style={{margin: '5px 0 0 0', fontSize: 12, color: '#666', textAlign: 'center'}}>{(operation.investissements || '').length}/255</p>
                                </div>
                                <div style={{display: 'flex', flex: 1, flexDirection: 'column'}}>
                                <textarea
                                    rows={5}
                                    maxLength={255}
                                    style={{ flex: 1, padding: 5 }}
                                    onChange={(e) => updateField('investissements', e.target.value)}
                                    value={operation.investissements || ''}
                                />
                                </div>
                            </div>

                            {/* Incidences organisationnelles */}
                            <div style={{display: 'flex', margin: 10}} className='shadow-md rounded-md'>
                                <div style={{flex: 0.3, padding: 10, backgroundColor: greyChapter, alignItems: 'center', minWidth: 175, display: 'flex', flexDirection: 'column'}}>
                                    <p>Incidences organisationnelles</p>
                                    <p style={{margin: '5px 0 0 0', fontSize: 12, color: '#666', textAlign: 'center'}}>{(operation.incidences_orga || '').length}/255</p>
                                </div>
                                <div style={{display: 'flex', flex: 1, flexDirection: 'column'}}>
                                <textarea
                                    rows={5}
                                    maxLength={255}
                                    style={{ flex: 1, padding: 5 }}
                                    onChange={(e) => updateField('incidences_orga', e.target.value)}
                                    value={operation.incidences_orga || ''}
                                />
                                </div>
                            </div>

                        </div>
                        :null}

                        {/****************************** Échéancier ********************************/}
                        {echeancier?
                        <div>

                            {/* Études programmatiques */}
                            <div style={{display: 'flex', margin: 10, minHeight: 100}} className='shadow-md rounded-md'>
                                <div style={{flex: 0.3, padding: 10, backgroundColor: greyChapter, alignItems: 'center', minWidth: 175}}>
                                    <p>Études programmatiques</p>
                                </div>
                                <div style={{display: 'flex', flex: 1}}>
                                <textarea
                                    rows={5}
                                    style={{ flex: 1, padding: 5 }}
                                    onChange={(e) => updateField('etudes_programmatiques', e.target.value)}
                                    value={operation.etudes_programmatiques || ''}
                                />
                                </div>
                            </div>

                            <div style={{marginTop: 20}}>
                                <Gantt user={props.user} id_operation={id} operation={operation}/>
                            </div>

                        </div>
                        :null}

                        {/****************************** Incidences Financières ********************************/}
                        {incidences?
                        (operation && operation.date_premiere_acquisition && operation.date_premiere_facturation && operation.duree_portage && operation.duree_portage > 0 && operation.id_modalite_portage?
                        (new Date(operation.date_premiere_facturation) >= new Date(operation.date_premiere_acquisition)?
                        <IncidencesFinancieresOperations
                            incidences={incidences}
                            operation={operation}
                            incidences_financieres={incidences_financieres}
                            updateIncidencesFinancieres={updateIncidencesFinancieres}
                            blue={blue}
                            purple={purple}
                            updateField={updateField}
                            calculateIncidencesField={calculateIncidencesField}
                            recalculateAfterBlur={recalculateAfterBlur}
                            modalite_portage={modalite_portage_selectionnee}
                        />
                        :
                        <div style={{textAlign: 'center', marginTop: 50, padding: 20}} className='shadow-md rounded-md'>
                            <p style={{color: 'red', fontSize: 16}}>Erreur : La date de 1ère facturation doit être supérieure ou égale à la date d'acquisition</p>
                        </div>
                        )
                        :
                        <div style={{textAlign: 'center', marginTop: 50, padding: 20}} className='shadow-md rounded-md'>
                            <p style={{color: 'red', fontSize: 16}}>Veuillez renseigner tous les champs obligatoires dans l'onglet 'Données générales' :</p>
                            <ul style={{color: '#666', textAlign: 'left', display: 'inline-block'}}>
                                {!operation.date_premiere_acquisition && <li>Date de 1ère acquisition</li>}
                                {!operation.date_premiere_facturation && <li>Date de 1ère facturation</li>}
                                {!operation.duree_portage || operation.duree_portage <= 0 && <li>Durée de portage (doit être supérieure à 0)</li>}
                                {!operation.id_modalite_portage && <li>Modalité de portage</li>}
                            </ul>
                        </div>
                        )
                        :null}

                        {/****************************** Évaluation ********************************/}
                        {evaluation?
                        <div>

                            {/* Description des objectifs */}
                            <div style={{display: 'flex', margin: 10, minHeight: 150}} className='shadow-md rounded-md'>
                                <div style={{padding: 10, backgroundColor: greyChapter, alignItems: 'center', width: 350}}>
                                    <p>Description des objectifs</p>
                                </div>
                                <div style={{display: 'flex', flex: 1}}>
                                    <textarea
                                    rows={5}
                                    style={{flex: 1, padding: 5}}
                                    onChange={(e) => updateField('description_objectifs', e.target.value)}
                                    onBlur={() => {
                                        const trimmed = operation.description_objectifs ? operation.description_objectifs.trim() : '';
                                        updateField('description_objectifs', trimmed);
                                    }}
                                    value={operation.description_objectifs === null ? "" : rescueHtml(operation.description_objectifs)}
                                    />
                                </div>
                            </div>

                            <div style={{display: 'flex'}}>
                                {/* Niveau atteinte des objectifs */}
                                <div style={{flex: 1, display: 'flex', margin: 10, minHeight: 150}} className='shadow-md rounded-md'>
                                    <div style={{padding: 10, backgroundColor: greyChapter, alignItems: 'center', width: 350}}>
                                        <p>Niveau atteinte des objectifs</p>
                                    </div>
                                    <div style={{display: 'flex', flex: 1}}>
                                        <textarea
                                        rows={5}
                                        style={{flex: 1, padding: 5}}
                                        onChange={(e) => updateField('niveau_atteinte_objectifs', e.target.value)}
                                        onBlur={() => {
                                            const trimmed = operation.niveau_atteinte_objectifs ? operation.niveau_atteinte_objectifs.trim() : '';
                                            updateField('niveau_atteinte_objectifs', trimmed);
                                        }}
                                        value={operation.niveau_atteinte_objectifs === null ? "" : rescueHtml(operation.niveau_atteinte_objectifs)}
                                        />
                                    </div>
                                </div>

                                {/* Jauge - note */}
                                <div style={{display: 'flex'}}>
                                    <div style={{flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: 150}}>
                                        <div>
                                            <GaugeComponent
                                                type="radial"
                                                arc={{
                                                    width: 0.3,
                                                    padding: 0.02,
                                                    cornerRadius: 3,
                                                    subArcs: [
                                                        { limit: 1, color: '#FF0000' },
                                                        { limit: 2, color: '#FF4D4D' },
                                                        { limit: 3, color: '#FF6666' },
                                                        { limit: 4, color: '#FFDB99' },
                                                        { limit: 5, color: '#FFBF40' },
                                                        { limit: 6, color: '#FFA500' },
                                                        { limit: 7, color: '#CCBF33' },
                                                        { limit: 8, color: '#99CC66' },
                                                        { limit: 9, color: '#85C97A' },
                                                        { limit: 10, color: '#59B44A' }
                                                    ]
                                                }}
                                                pointer={{
                                                    color: purple,
                                                    length: 0.7,
                                                    width: 20
                                                }}
                                                value={operation.note !== null && operation.note !== undefined ? operation.note : 0}
                                                labels={{
                                                    valueLabel: { style: { display: 'none' } }
                                                }}
                                                minValue={0}
                                                maxValue={10}
                                                style={{flex: 1}}
                                            />
                                        
                                            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 25}}>
                                                <input
                                                    className='shadow-md rounded-md'
                                                    style={{width: 40, textAlign: 'center'}}
                                                    min={0}
                                                    max={10}
                                                    step={1}
                                                    onBlur={(e) => {
                                                        let val = parseInt(e.target.value, 10);
                                                        if (isNaN(val)) val = 0;
                                                        if (val < 0) val = 0;
                                                        if (val > 10) val = 10;
                                                        updateField('note', val);
                                                    }}
                                                    value={operation.note !== null && operation.note !== undefined ? operation.note : 0}
                                                    onChange={e => {
                                                        let val = e.target.value;
                                                        if (val === "") {
                                                            updateField('note', "");
                                                        } else {
                                                            let num = parseInt(val, 10);
                                                            if (!isNaN(num) && num >= 0 && num <= 10) {
                                                                updateField('note', num);
                                                            }
                                                        }
                                                    }}
                                                />
                                                <p>/ 10</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Ajustement des objectifs */}
                            <div style={{display: 'flex', margin: 10, minHeight: 150}} className='shadow-md rounded-md'>
                                <div style={{padding: 10, backgroundColor: greyChapter, alignItems: 'center', width: 350}}>
                                    <p>Ajustement des objectifs</p>
                                </div>
                                <div style={{display: 'flex', flex: 1}}>
                                    <textarea
                                    rows={5}
                                    style={{flex: 1, padding: 5}}
                                    onChange={(e) => updateField('ajustement_objectifs', e.target.value)}
                                    onBlur={() => {
                                        const trimmed = operation.ajustement_objectifs ? operation.ajustement_objectifs.trim() : '';
                                        updateField('ajustement_objectifs', trimmed);
                                    }}
                                    value={operation.ajustement_objectifs === null ? "" : rescueHtml(operation.ajustement_objectifs)}
                                    />
                                </div>
                            </div>

                        </div>
                        :null}

                        {/****************************** Pilotage ********************************/}
                        {pilotage?
                        <div>
                            <div style={{flex: 1, display: 'flex', borderTopLeftRadius: 2}}>
                                <div style={{flex: 0.15, minWidth: 20, justifyContent: 'center', alignItems: 'center', display: 'flex'}}>
                                    <Trash width="15" />
                                </div>
                                <div style={{flex: 0.6, minWidth: 90, justifyContent: 'center', alignItems: 'center', display: 'flex'}}>
                                    <p style={{}}>Date</p>
                                </div>
                                <div style={{flex: 1, minWidth: 180, justifyContent: 'center', alignItems: 'center', display: 'flex'}}>
                                    <p style={{}}>Instance réunie</p>
                                </div>
                                <div style={{flex: 1.5, minWidth: 300, justifyContent: 'center', alignItems: 'center', display: 'flex'}}>
                                    <p style={{}}>Relevé de décisions</p>
                                </div>
                                <div style={{flex: 1.5, minWidth: 300, justifyContent: 'center', alignItems: 'center', display: 'flex'}}>
                                    <p style={{}}>Action suivante</p>
                                </div>
                                <div style={{flex: 0.6, minWidth: 90, justifyContent: 'center', alignItems: 'center', display: 'flex'}}>
                                    <p style={{}}>Date limite de l'action</p>
                                </div>
                                <div style={{flex: 1, minWidth: 130, justifyContent: 'center', alignItems: 'center', display: 'flex'}}>
                                    <p style={{}}>Responsable de l'action</p>
                                </div>
                            </div>

                            <div style={{flex: 1, height: heightObject, borderBottomRightRadius: 3, borderBottomLeftRadius: 3}}>
                                {pilotage_operation.map((line, i) =>
                                
                                <div key={i} style={{flex: 1, display: 'flex', marginTop: 5, backgroundColor: line[10] == 1? green:line[10] == 0 && (new Date(line[7])) <= (new Date()) ? red : '#ffffff'}} className='shadow-md'>
                                    
                                    <button
                                    style={{flex: 0.15, minWidth: 20, justifyContent: 'center', alignItems: 'center', display: 'flex'}}
                                    onClick={async () => {
                                        await setDialogModalVisible(true);
                                        await setPilotageLineSelected(line[0]);
                                    }}
                                    >
                                        <Trash width="16" />
                                    </button>

                                    {/* Date */}
                                    <button
                                    onClick={(e) => {
                                        setModalPilotage(true);
                                        setObjetPilotage(line);
                                    }}
                                        style={{display: 'flex', flex: 0.6, minWidth: 90, alignItems: 'center', justifyContent: 'center', textAlign: 'center'}}
                                    >
                                        <p>{line[3]?line[3].split('-')[2]+'/'+line[3].split('-')[1]+'/'+line[3].split('-')[0]:null}</p>
                                    </button>

                                    {/* Instance reunie */}
                                    <button
                                    onClick={(e) => {
                                        setModalPilotage(true);
                                        setObjetPilotage(line);
                                    }}
                                        style={{display: 'flex', flex: 1, minWidth: 180, alignItems: 'center', justifyContent: 'center'}}
                                    >
                                        <p>{rescueHtml(line[4])}</p>
                                    </button>

                                    {/* Releve de decision */}
                                    <button
                                    onClick={(e) => {
                                        setModalPilotage(true);
                                        setObjetPilotage(line);
                                    }}
                                        style={{display: 'flex', flex: 1.5, minWidth: 300, alignItems: 'center', justifyContent: 'center'}}
                                    >
                                        <p>
                                            {
                                            rescueHtml(line[5])
                                            .split('\\n')[0]
                                            .slice(0, 35) + (rescueHtml(line[5]).split('\\n')[0].length > 35 ? '...' : '')
                                            }
                                        </p>
                                    </button>

                                    {/* Action suivante */}
                                    <button
                                    onClick={(e) => {
                                        setModalPilotage(true);
                                        setObjetPilotage(line);
                                    }}
                                        style={{display: 'flex', flex: 1.5, minWidth: 300, alignItems: 'center', justifyContent: 'center'}}
                                    >
                                        <p>
                                            {
                                            rescueHtml(line[6])
                                            .split('\\n')[0]
                                            .slice(0, 35) + (rescueHtml(line[6]).split('\\n')[0].length > 35 ? '...' : '')
                                            }
                                        </p>
                                    </button>

                                    {/* Date limite */}
                                    <button
                                    onClick={(e) => {
                                        setModalPilotage(true);
                                        setObjetPilotage(line);
                                    }}
                                        style={{display: 'flex', flex: 0.6, minWidth: 90, alignItems: 'center', justifyContent: 'center', textAlign: 'center'}}
                                    >
                                        <p>{line[7]?line[7].split('-')[2]+'/'+line[7].split('-')[1]+'/'+line[7].split('-')[0]:null}</p>
                                    </button>

                                    {/* Responsable de saisie */}
                                    <button
                                    onClick={(e) => {
                                        setModalPilotage(true);
                                        setObjetPilotage(line);
                                    }}
                                        style={{display: 'flex', flex: 1, minWidth: 130, alignItems: 'center', justifyContent: 'center', textAlign: 'center'}}
                                    >
                                        <p>{line[8]}</p>
                                    </button>

                                </div>
                                )}
                                <div style={{display: 'flex'}}>
                                    <div style={{flex: 1}}></div>
                                    <div style={{marginTop: 10, marginBottom: 10}}>
                                    <button
                                        className='shadow-md rounded-md'
                                        style={{backgroundColor: purple, color: 'white', fontSize: 17, alignItems: 'center', justifyContent: 'center', display: 'flex', paddingLeft: 10, paddingRight: 10}}
                                        onClick={async () => {
                                            addLinePilotage();
                                        }}
                                    >
                                        <Add width="12" />
                                        <p style={{marginLeft: 10}}>Ajouter une ligne</p>
                                    </button>
                                    </div>
                                    <div style={{flex: 1}}></div>
                                </div>
                            </div>
                            
                        </div>
                        :null}

                    </div>
                    :
                    <div style={{textAlign: 'center', marginTop: 50}}>
                        <p>Chargement...</p>
                    </div>
                    }
                </div>

            </Access>
        </div>
    );
}

export default OperationPage;
